// src/components/ClickableLink.js
import React from 'react';

/**
 * A thin wrapper around a standard anchor tag that:
 *  – Always opens in a new tab (safer for external / pdf links)
 *  – Adds rel="noopener noreferrer" for security
 *  – Exposes an onClick callback that receives the href (so analytics callers
 *    don’t have to read from the event object).
 */
const ClickableLink = ({ href, onClick, children, className = '' }) => {
  const handleClick = (e) => {
    if (typeof onClick === 'function') {
      onClick(href, e);
    }
  };

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      className={`underline underline-offset-4 hover:no-underline ${className}`.trim()}
    >
      {children}
    </a>
  );
};

export default ClickableLink;
